import { IconButton } from '@chakra-ui/react';
import showMessage from 'providers/NoticeProvider/showMessage';
import { BsCopy } from 'react-icons/bs';

const CopyButton = ({ value }: { value: string }) => {
    const handleClick = () => {
        navigator.clipboard.writeText(value);
        showMessage('Copied!');
    };

    return (
        <IconButton borderRadius={'50%'} bg={'transparent'} aria-label="copy" icon={<BsCopy />} onClick={handleClick} />
    );
};

export default CopyButton;
